import React, { useState } from "react";
import { Grid } from "@mui/material";
import Header from "./Header";
import HomeTable from "./HomeTable";

const Canvas = () => {

  return (
    <>
<Grid container spacing={4} height="100%">
      <Grid item sm={12} md={12}>
        <Header title="Canvas" />
      </Grid>
      <Grid item sm={12} md={12}>
        <HomeTable sortData="Editing"/>
      </Grid>
    </Grid>
    </>
  );
};

export default Canvas;